(function () {
  'use strict';

  const root = document.querySelector('[data-sf-wizard]');
  if (!root) return;

  const cfg = {
    productId: root.dataset.productId,
    productHandle: root.dataset.productHandle,
    variantId: root.dataset.variantId,
    productTitle: root.dataset.productTitle,
    flowStep: root.dataset.flowStep || 'product',
    zoneName: root.dataset.zoneName || '',
    zoneSize: root.dataset.zoneSize || '',
    defaultZoneKey: root.dataset.defaultZoneKey || '',
    defaultStarId: root.dataset.defaultStarId || '',
    selectableMap: root.dataset.selectableMap === 'true',
    cardZoneSelect: root.dataset.cardZoneSelect === 'true',
    skipZoneStep: root.dataset.skipZoneStep === 'true',
    mapUrl: root.dataset.mapUrl || '',
    zones: safeJson(root.dataset.zonesJson || '[]'),
    showPlaque: root.dataset.showPlaque === 'true',
    plaqueVariantId: root.dataset.plaqueVariantId || null,
    plaquePrice: root.dataset.plaquePrice || '',
    plaqueCompareAt: root.dataset.plaqueCompareAt || '',
    zoneVariants: safeJson(root.dataset.zoneVariantsJson || '[]'),
    requiresCompanyUrl: root.dataset.requiresCompanyUrl === 'true',
    requiresLocaDetails: root.dataset.requiresLocaDetails === 'true',
    requiresExtraDetail: root.dataset.requiresExtraDetail === 'true',
    soldOut: root.dataset.soldOut === 'true',
  };
  const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

  function safeJson(value) {
    try { return JSON.parse(value); } catch (_) { return []; }
  }

  const form = root.querySelector('[data-sf-form]');
  const stepper = root.querySelectorAll('.sf-stepper__item');
  const tipiRadios = root.querySelectorAll('[data-sf-tipi]');
  const customizeBtn = root.querySelector('[data-sf-customize]');
  const customizeSection = root.querySelector('[data-sf-customize-section]');
  const backBtn = root.querySelector('[data-sf-back]');
  const infoSection = root.querySelector('[data-sf-info]');
  const mainImg = root.querySelector('[data-sf-main-img]');
  const thumbs = root.querySelectorAll('[data-sf-thumb]');
  const zoneSelect = root.querySelector('[data-sf-zone-select]');
  const zoneMap = root.querySelector('[data-sf-zone-map]');
  const zoneOptions = root.querySelector('[data-sf-zone-options]');
  const zoneContinue = root.querySelector('[data-sf-zone-continue]');
  const editGrid = root.querySelector('[data-sf-edit-grid]');
  const selectedZoneEmpty = root.querySelector('[data-sf-selected-zone-empty]');
  const selectedZoneCard = root.querySelector('[data-sf-selected-zone-card]');
  const selectedZoneName = root.querySelector('[data-sf-selected-zone-name]');
  const selectedZoneSize = root.querySelector('[data-sf-selected-zone-size]');
  const selectedZoneUpgrade = root.querySelector('[data-sf-selected-zone-upgrade]');
  const selectedZoneNote = root.querySelector('[data-sf-selected-zone-note]');
  const noteZoneName = root.querySelector('[data-sf-note-zone-name]');
  const noteZoneSize = root.querySelector('[data-sf-note-zone-size]');
  const locaNumberInput = root.querySelector('[data-sf-loca-number]');
  const locaShippingInput = root.querySelector('[data-sf-loca-shipping]');
  const locaModal = root.querySelector('[data-sf-loca-modal]');
  const locaModalInput = root.querySelector('[data-sf-loca-modal-input]');
  const locaModalSave = root.querySelector('[data-sf-loca-modal-save]');
  const zoneByKey = new Map((cfg.zones || []).map((z) => [z.key, z]));
  const zoneVariantByKey = new Map((cfg.zoneVariants || []).map((variant) => [variant.key, variant]));
  const STADIUM_ZONE_SHAPE_ALIASES = {
    maraton_ust: ['unselectable'],
    maraton_alt: ['unselectable_2'],
    fenerium_ust: ['unselectable_4'],
    fenerium_alt_loca_a: ['unselectable_3'],
    fenerium_alt_loca_b: ['unselectable_5'],
  };
  const stadiumShapeKeyToZoneKey = new Map(
    Object.entries(STADIUM_ZONE_SHAPE_ALIASES).flatMap(([zoneKey, shapeKeys]) => (
      shapeKeys.map((shapeKey) => [shapeKey, zoneKey])
    ))
  );
  let selectedZone = null;
  let locaUiReady = false;
  let locaModalHadSavedNumber = false;

  // ---------- Separate-page flow helpers ----------
  // Product, Bölge Seç and Düzenle are rendered as separate Shopify views:
  //   1. /products/<handle>
  //   2. /products/<handle>?view=bolge-sec
  //   3. /products/<handle>?view=duzenle
  // Cart and checkout remain Shopify's native /cart and /checkout pages.
  const zoneStorageKey = `sf_zone_${cfg.productHandle}`;
  const locaNumberStorageKey = `sf_loca_number_${cfg.productHandle}`;
  const locaShippingStorageKey = `sf_loca_shipping_${cfg.productHandle}`;

  function readZoneFromUrlOrStorage() {
    const params = new URLSearchParams(window.location.search);
    let storedKey = '';
    try {
      storedKey = sessionStorage.getItem(zoneStorageKey) || '';
    } catch (_) {}
    const key = params.get('sf_zone') || storedKey;
    return zoneByKey.get(key) || null;
  }

  function readDefaultZone() {
    if (cfg.defaultZoneKey && zoneByKey.has(cfg.defaultZoneKey)) return zoneByKey.get(cfg.defaultZoneKey);
    return null;
  }

  function persistSelectedZone() {
    try {
      if (selectedZone?.key) {
        sessionStorage.setItem(zoneStorageKey, selectedZone.key);
      } else {
        sessionStorage.removeItem(zoneStorageKey);
      }
    } catch (_) {}
  }

  function buildEditUrl(zone) {
    const base = zoneContinue?.dataset.editUrl || `${window.location.pathname}?view=duzenle`;
    const url = new URL(base, window.location.origin);
    if (zone?.key) url.searchParams.set('sf_zone', zone.key);
    const loca = readLocaSelection();
    if (cfg.requiresLocaDetails || zoneRequiresLoca(zone)) {
      if (loca.shipping) {
        url.searchParams.set('loca_teslimat', 'kargo');
        url.searchParams.delete('loca_numarasi');
      } else if (loca.number) {
        url.searchParams.set('loca_numarasi', loca.number);
        url.searchParams.delete('loca_teslimat');
      }
    }
    return url.toString();
  }

  function zoneRequiresLoca(zone = selectedZone) {
    return Boolean(zone && (zone.key === 'loca' || zone.requiresLocaNumber));
  }

  function readLocaSelection() {
    const params = new URLSearchParams(window.location.search);
    let storedNumber = '';
    let storedShipping = false;
    try {
      storedNumber = sessionStorage.getItem(locaNumberStorageKey) || '';
      storedShipping = sessionStorage.getItem(locaShippingStorageKey) === 'true';
    } catch (_) {}
    const number = (params.get('loca_numarasi') || locaModalInput?.value || locaNumberInput?.value || storedNumber || '').replace(/\D/g, '');
    let shipping = cfg.requiresLocaDetails && (params.get('loca_teslimat') === 'kargo' || storedShipping);
    if (cfg.requiresLocaDetails && locaShippingInput) {
      shipping = locaUiReady ? Boolean(locaShippingInput.checked) : (Boolean(locaShippingInput.checked) || storedShipping);
    }
    return { number, shipping };
  }

  function persistLocaSelection() {
    if (!cfg.requiresLocaDetails && !zoneRequiresLoca()) return;
    const loca = readLocaSelection();
    try {
      if (loca.number) sessionStorage.setItem(locaNumberStorageKey, loca.number);
      else sessionStorage.removeItem(locaNumberStorageKey);
      sessionStorage.setItem(locaShippingStorageKey, loca.shipping ? 'true' : 'false');
    } catch (_) {}
  }

  function isValidLocaNumber(value) {
    const n = parseInt(value, 10);
    return (n >= 1 && n <= 20) || (n >= 101 && n <= 130);
  }

  function formatLocaDisplay(number) {
    return number ? `Özel Loca ${number}` : 'Özel Loca';
  }

  function openLocaModal() {
    if (!locaModal || !locaModalInput) return;
    const loca = readLocaSelection();
    locaModalHadSavedNumber = Boolean(loca.number);
    locaModalInput.value = loca.number || '';
    clearError('loca_modal');
    locaModal.hidden = false;
    document.body.style.overflow = 'hidden';
    locaModalInput.focus();
  }

  function closeLocaModal({ clearSelection = false } = {}) {
    if (!locaModal) return;
    locaModal.hidden = true;
    document.body.style.overflow = '';
    if (clearSelection && selectedZone && zoneRequiresLoca(selectedZone) && !locaModalHadSavedNumber) {
      try {
        sessionStorage.removeItem(locaNumberStorageKey);
      } catch (_) {}
      if (locaModalInput) locaModalInput.value = '';
      paintZone(selectedZone.key, false);
      selectedZone = null;
      updateSelectedZoneUi();
    }
  }

  function saveLocaModal() {
    if (!locaModalInput) return;
    locaModalInput.value = locaModalInput.value.replace(/\D/g, '');
    const loca = readLocaSelection();
    if (!loca.number || !isValidLocaNumber(loca.number)) {
      showError('loca_modal', 'Özel loca numarası 1-20 veya 101-130 aralığında olmalıdır.');
      return;
    }
    persistLocaSelection();
    updateSelectedZoneUi();
    closeLocaModal();
  }

  // ---------- Zone selector (Fenerbahçe map products) ----------
  let zoneMapInitialized = false;
  async function initZoneMap() {
    if (!cfg.selectableMap || !zoneMap || zoneMapInitialized) return;
    zoneMapInitialized = true;
    if (!cfg.mapUrl) {
      zoneMap.innerHTML = '<p class="sf-zone-select__missing">Bölge haritası yüklenemedi.</p>';
      return;
    }
    try {
      const res = await fetch(cfg.mapUrl, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('map failed');
      const text = await res.text();
      zoneMap.innerHTML = text.replace(/<script[\s\S]*?<\/script>/gi, '');
      prepareZoneSvg();
    } catch (_) {
      zoneMap.innerHTML = '<p class="sf-zone-select__missing">Bölge haritası yüklenemedi.</p>';
    }
  }

  function cssEscape(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function prepareZoneSvg() {
    const svg = zoneMap && zoneMap.querySelector('svg');
    if (!svg) return;
    svg.removeAttribute('width');
    svg.removeAttribute('height');
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-label', 'Fenerbahçe StarFan bölge haritası');
    const selectableKeys = new Set(zoneByKey.keys());
    const useStadiumLabels = isStadiumZoneMap();
    if (zoneMap) zoneMap.classList.toggle('sf-zone-select__map--stadium', useStadiumLabels);
    const seenSelectableNodes = new Set();
    svg.querySelectorAll('[id]').forEach((node) => {
      const key = node.id;
      const effectiveKey = useStadiumLabels ? (stadiumShapeKeyToZoneKey.get(key) || key) : key;
      if (node.closest('[data-sf-zone-label="legacy"]')) {
        markLegacyZoneLabel(node);
        return;
      }
      if (!node.dataset.sfOriginalFill) {
        node.dataset.sfOriginalFill = node.getAttribute('fill') || '';
        node.dataset.sfOriginalStroke = node.getAttribute('stroke') || '';
        node.dataset.sfOriginalFilter = node.getAttribute('filter') || '';
      }
      if (selectableKeys.has(effectiveKey)) {
        if (useStadiumLabels && seenSelectableNodes.has(effectiveKey)) {
          markLegacyZoneLabel(node);
          node.setAttribute('fill', '#ffffff');
          return;
        }
        seenSelectableNodes.add(effectiveKey);
        node.classList.add('sf-zone-path', 'is-selectable');
        node.style.cursor = 'pointer';
        node.setAttribute('tabindex', '0');
        node.setAttribute('role', 'button');
        node.dataset.sfZoneKey = effectiveKey;
        node.setAttribute('aria-label', zoneByKey.get(effectiveKey).name);
        node.addEventListener('click', () => toggleZone(effectiveKey));
        node.addEventListener('mouseenter', () => setZoneLabelActive(effectiveKey, true));
        node.addEventListener('mouseleave', () => setZoneLabelActive(effectiveKey, false));
        node.addEventListener('focus', () => setZoneLabelActive(effectiveKey, true));
        node.addEventListener('blur', () => setZoneLabelActive(effectiveKey, false));
        node.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleZone(effectiveKey); }
        });
      } else {
        if (useStadiumLabels && isLegacyZoneLabel(node, key)) {
          markLegacyZoneLabel(node);
          return;
        }
        if (useStadiumLabels && isUnavailableStadiumZone(node, key)) {
          node.classList.add('sf-zone-path', 'is-disabled');
          node.style.cursor = 'default';
          return;
        }
        if (useStadiumLabels) {
          node.classList.add('sf-zone-path', 'is-map-detail');
          node.style.cursor = 'default';
          return;
        }
        node.classList.add('sf-zone-path', 'is-disabled');
        node.style.cursor = 'default';
      }
    });
    if (useStadiumLabels) renderStadiumZoneLabels(svg, selectableKeys);
    if (selectedZone?.key) paintZone(selectedZone.key, true);
  }

  function isStadiumZoneMap() {
    return ['taraftar-yildizi', 'super-yildiz'].includes(cfg.productHandle);
  }

  function isUnavailableStadiumZone(node, key) {
    const tag = node.tagName && node.tagName.toLowerCase();
    return tag === 'path' && /^unselectable(?:_|$)/.test(key);
  }

  function isLegacyZoneLabel(node, key) {
    const tag = node.tagName && node.tagName.toLowerCase();
    if (tag !== 'path' && tag !== 'text' && tag !== 'g') return false;
    if (/^Vector_(?:[8-9]|1[0-5])$/.test(key)) return true;
    const readableId = /[A-Z\s&;]/.test(key);
    const hasLabelOpacity = node.hasAttribute('fill-opacity') || node.style.opacity;
    return (readableId || hasLabelOpacity) && /maraton|fenerium|kuzey|spor|avlu|trib|loca/i.test(key);
  }

  function markLegacyZoneLabel(node) {
    node.dataset.sfZoneLabel = 'legacy';
    node.classList.remove('sf-zone-path', 'is-selectable', 'is-disabled', 'is-map-detail');
    node.removeAttribute('tabindex');
    node.removeAttribute('role');
    node.removeAttribute('aria-label');
    node.style.pointerEvents = 'none';
    node.style.opacity = '1';
    node.style.display = 'none';
    node.querySelectorAll('*').forEach((child) => {
      child.dataset.sfZoneLabel = 'legacy';
      child.classList.remove('sf-zone-path', 'is-selectable', 'is-disabled', 'is-map-detail');
      child.removeAttribute('tabindex');
      child.removeAttribute('role');
      child.removeAttribute('aria-label');
      child.style.pointerEvents = 'none';
      child.style.opacity = '1';
      child.style.display = 'none';
    });
  }

  function renderStadiumZoneLabels(svg, selectableKeys) {
    if (svg.querySelector('[data-sf-stadium-labels]')) return;

    const ns = 'http://www.w3.org/2000/svg';
    const labels = [
      { key: 'maraton_alt', lines: ['Maraton Alt'], x: 225, y: 23, size: 8.5 },
      { key: 'maraton_ust', lines: ['Maraton Üst'], x: 225, y: 51, size: 8.5 },
      { key: 'kuzey_tribunu', lines: ['Kuzey', 'Tribünü'], x: 62, y: 150, size: 9.5 },
      { key: 'spor_toto_tribunu', lines: ['Spor Toto', 'Tribünü'], x: 376, y: 150, size: 9.5 },
      { key: 'fenerium_ust', lines: ['Fenerium Üst'], x: 225, y: 253, size: 8.5 },
      { key: 'fenerium_alt_loca_b', lines: ['Fenerium Alt', 'Loca B'], x: 148, y: 283, size: 7.5 },
      { key: 'fenerium_alt_loca_a', lines: ['Fenerium Alt', 'Loca A'], x: 302, y: 283, size: 7.5 },
      { key: 'avlu', lines: ['Avlu'], x: 225, y: 334, size: 8 },
    ];

    const group = document.createElementNS(ns, 'g');
    group.dataset.sfStadiumLabels = 'true';
    group.classList.add('sf-zone-map-labels');
    group.setAttribute('pointer-events', 'none');

    labels.forEach((label) => {
      const text = document.createElementNS(ns, 'text');
      text.classList.add('sf-zone-map-label', selectableKeys.has(label.key) ? 'sf-zone-map-label--selectable' : 'sf-zone-map-label--muted');
      text.dataset.sfZoneKey = label.key;
      text.setAttribute('x', label.x);
      text.setAttribute('y', label.y);
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('font-family', 'Inter, Arial, sans-serif');
      text.setAttribute('font-size', String(label.size));
      text.setAttribute('font-weight', '700');
      text.setAttribute('fill', '#ffffff');
      text.setAttribute('opacity', '1');
      text.style.pointerEvents = 'none';

      label.lines.forEach((line, index) => {
        const tspan = document.createElementNS(ns, 'tspan');
        tspan.setAttribute('x', label.x);
        if (index > 0) tspan.setAttribute('dy', String(label.size + 1));
        tspan.textContent = line;
        text.appendChild(tspan);
      });
      group.appendChild(text);
    });

    svg.appendChild(group);
  }

  function nodesForZone(key) {
    if (!zoneMap) return [];
    const ids = [key, ...(isStadiumZoneMap() ? (STADIUM_ZONE_SHAPE_ALIASES[key] || []) : [])];
    const nodes = ids.flatMap((id) => [...zoneMap.querySelectorAll(`#${cssEscape(id)}`)]);
    return [...new Set(nodes)].filter((node) => node.dataset.sfZoneLabel !== 'legacy');
  }

  function labelsForZone(key) {
    if (!zoneMap) return [];
    return [...zoneMap.querySelectorAll(`[data-sf-zone-key="${cssEscape(key)}"]`)];
  }

  function setZoneLabelActive(key, hoverActive) {
    labelsForZone(key).forEach((label) => {
      const selected = selectedZone && selectedZone.key === key;
      label.classList.toggle('sf-zone-map-label--active', hoverActive || selected);
    });
  }

  function rememberOriginalFill(target) {
    if (!Object.prototype.hasOwnProperty.call(target.dataset, 'sfOriginalFill')) {
      target.dataset.sfOriginalFill = target.getAttribute('fill') || '';
    }
    if (!Object.prototype.hasOwnProperty.call(target.dataset, 'sfOriginalStyleFill')) {
      target.dataset.sfOriginalStyleFill = target.style.fill || '';
    }
  }

  function paintZone(key, active) {
    nodesForZone(key).forEach((node) => {
      const targets = [node, ...node.querySelectorAll('path, rect, polygon, polyline, circle, ellipse')];
      targets.forEach((target) => {
        rememberOriginalFill(target);
        target.classList.toggle('is-selected', active);
        if (active) {
          target.setAttribute('fill', '#FFED00');
          target.style.setProperty('fill', '#FFED00', 'important');
        } else {
          const originalFill = target.dataset.sfOriginalFill;
          const originalStyleFill = target.dataset.sfOriginalStyleFill;
          if (originalFill) target.setAttribute('fill', originalFill); else target.removeAttribute('fill');
          target.style.removeProperty('fill');
          if (originalStyleFill) target.style.fill = originalStyleFill;
        }
      });
      if (active) {
        node.setAttribute('fill', '#FFED00');
        node.classList.add('is-selected');
      } else {
        const original = node.dataset.sfOriginalFill;
        if (original) node.setAttribute('fill', original); else node.removeAttribute('fill');
        node.classList.remove('is-selected');
      }
    });
    labelsForZone(key).forEach((label) => {
      label.classList.toggle('sf-zone-map-label--active', active);
    });
  }

  function toggleZone(key) {
    clearError('zone_select');
    if (selectedZone && selectedZone.key === key) {
      paintZone(key, false);
      selectedZone = null;
      updateSelectedZoneUi();
    } else {
      selectZone(key);
    }
  }

  function updateSelectedZoneUi() {
    const loca = (cfg.requiresLocaDetails || zoneRequiresLoca()) ? readLocaSelection() : null;
    const requiresExplicitZone = cfg.selectableMap || cfg.cardZoneSelect;
    const has = requiresExplicitZone
      ? Boolean(selectedZone)
      : Boolean(selectedZone) || Boolean(loca?.shipping) || Boolean(loca?.number) || (!cfg.requiresLocaDetails && Boolean(cfg.zoneName));
    const displayName = zoneRequiresLoca()
      ? formatLocaDisplay(loca?.number)
      : (selectedZone?.name || (loca?.shipping ? 'Eve Teslim' : (loca?.number ? `Loca ${loca.number}` : cfg.zoneName)));
    const displaySize = selectedZone?.size || cfg.zoneSize || '';
    const upgradeText = selectedZone ? zoneUpgradeText(selectedZone) : '';
    if (selectedZoneEmpty) selectedZoneEmpty.hidden = has;
    if (selectedZoneCard) selectedZoneCard.hidden = !has;
    if (selectedZoneName) selectedZoneName.textContent = has ? displayName : '';
    if (selectedZoneSize) {
      selectedZoneSize.hidden = true;
      selectedZoneSize.textContent = '';
    }
    if (selectedZoneUpgrade) {
      selectedZoneUpgrade.hidden = !upgradeText;
      selectedZoneUpgrade.textContent = upgradeText;
    }
    if (selectedZoneNote) selectedZoneNote.hidden = !has;
    if (noteZoneName) noteZoneName.textContent = has ? [displayName, upgradeText].filter(Boolean).join(' · ') : '';
    if (noteZoneSize) {
      noteZoneSize.hidden = true;
      noteZoneSize.textContent = '';
    }
    syncZoneOptionUi();
    persistSelectedZone();
  }

  function zonePriceDelta(zone) {
    if (zone?.upgradeGroup === 'mid') return '1000 TL';
    if (zone?.upgradeGroup === 'alt') return '2000 TL';
    return '';
  }

  function zoneUpgradeText(zone) {
    const delta = zonePriceDelta(zone);
    return delta ? `Bölge yükseltmesi: +${delta}` : '';
  }

  function zonePriceLabel(zone) {
    const delta = zonePriceDelta(zone);
    return delta ? `+${delta}` : 'Standart';
  }

  function selectedPackageVariantId() {
    if (selectedZone?.key) {
      const zoneVariant = zoneVariantByKey.get(selectedZone.key);
      if (zoneVariant?.id) return zoneVariant.id;
    }
    return cfg.variantId;
  }

  function setZoneFromOption(key) {
    selectZone(key);
  }

  function selectZone(key) {
    clearError('zone_select');
    if (selectedZone) paintZone(selectedZone.key, false);
    selectedZone = zoneByKey.get(key) || null;
    if (selectedZone) paintZone(selectedZone.key, true);
    updateSelectedZoneUi();
    if (cfg.flowStep === 'zone' && zoneRequiresLoca(selectedZone)) openLocaModal();
  }

  function syncZoneOptionUi() {
    if (!zoneOptions) return;
    zoneOptions.querySelectorAll('[data-sf-zone-option]').forEach((option) => {
      const active = Boolean(selectedZone && selectedZone.key === option.dataset.sfZoneOption);
      option.classList.toggle('is-active', active);
      const input = option.querySelector('input[type="radio"]');
      if (input) input.checked = active;
    });
  }

  function renderZoneOptions() {
    if (!zoneOptions || (!cfg.selectableMap && !cfg.cardZoneSelect) || !cfg.zones.length) return;

    zoneOptions.hidden = false;
    zoneOptions.innerHTML = '';

    const heading = document.createElement('p');
    heading.className = 'sf-zone-options__label';
    heading.textContent = 'Bölge seçenekleri';

    const list = document.createElement('div');
    list.className = 'sf-zone-options__list';

    cfg.zones.forEach((zone) => {
      const option = document.createElement('label');
      option.className = 'sf-zone-option';
      option.dataset.sfZoneOption = zone.key;
      option.addEventListener('click', () => {
        setZoneFromOption(zone.key);
      });

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `sf-zone-choice-${cfg.productHandle}`;
      input.value = zone.key;
      input.addEventListener('click', () => setZoneFromOption(zone.key));
      input.addEventListener('change', () => setZoneFromOption(zone.key));

      const body = document.createElement('span');
      body.className = 'sf-zone-option__body';

      const name = document.createElement('span');
      name.className = 'sf-zone-option__name';
      name.textContent = zone.name;

      const price = document.createElement('span');
      price.className = `sf-zone-option__price${zonePriceDelta(zone) ? ' sf-zone-option__price--paid' : ''}`;
      price.textContent = cfg.cardZoneSelect ? 'Standart' : zonePriceLabel(zone);

      body.appendChild(name);
      option.appendChild(input);
      option.appendChild(body);
      option.appendChild(price);
      list.appendChild(option);
    });

    zoneOptions.appendChild(heading);
    zoneOptions.appendChild(list);
    syncZoneOptionUi();
  }

  function syncLocaUi() {
    if (!cfg.requiresLocaDetails) return;
    const loca = readLocaSelection();
    if (locaNumberInput) {
      locaNumberInput.value = loca.number;
      locaNumberInput.disabled = loca.shipping;
    }
    if (locaShippingInput) locaShippingInput.checked = loca.shipping;
    locaUiReady = true;
    updateSelectedZoneUi();
  }

  function validateLocaSelection() {
    clearError('zone_select');
    const loca = readLocaSelection();
    if (loca.shipping) return true;
    if (!loca.number) return true;
    if (!isValidLocaNumber(loca.number)) {
      showError('zone_select', 'Özel loca numarası 1-20 veya 101-130 aralığında olmalıdır.');
      return false;
    }
    return true;
  }

  if (locaNumberInput) {
    locaNumberInput.addEventListener('input', () => {
      locaNumberInput.value = locaNumberInput.value.replace(/\D/g, '');
      persistLocaSelection();
      syncLocaUi();
    });
  }
  if (locaShippingInput) {
    locaShippingInput.addEventListener('change', () => {
      persistLocaSelection();
      syncLocaUi();
    });
  }
  if (locaModalInput) {
    locaModalInput.addEventListener('input', () => {
      locaModalInput.value = locaModalInput.value.replace(/\D/g, '');
      clearError('loca_modal');
    });
    locaModalInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        saveLocaModal();
      }
    });
  }
  if (locaModalSave) locaModalSave.addEventListener('click', saveLocaModal);
  if (locaModal) {
    locaModal.querySelectorAll('[data-sf-loca-modal-cancel]').forEach((el) => {
      el.addEventListener('click', () => closeLocaModal({ clearSelection: true }));
    });
    document.addEventListener('keydown', (event) => {
      if (!locaModal.hidden && event.key === 'Escape') closeLocaModal({ clearSelection: true });
    });
  }
  syncLocaUi();

  if (zoneContinue) {
    zoneContinue.addEventListener('click', () => {
      if (cfg.soldOut) return;
      if ((cfg.selectableMap || cfg.cardZoneSelect) && !selectedZone) {
        showError('zone_select', 'Lütfen önce bir tribün/bölge seçiniz.');
        return;
      }
      if (zoneRequiresLoca(selectedZone) && !readLocaSelection().number) {
        showError('zone_select', 'Lütfen özel loca numarasını giriniz.');
        openLocaModal();
        return;
      }
      if (cfg.requiresLocaDetails && !validateLocaSelection()) return;
      persistSelectedZone();
      persistLocaSelection();
      window.location.href = buildEditUrl(selectedZone);
    });
  }

  if (cfg.flowStep === 'zone') {
    selectedZone = readZoneFromUrlOrStorage();
    renderZoneOptions();
    initZoneMap();
    updateSelectedZoneUi();
    setStep(1);
  }

  if (cfg.flowStep === 'edit') {
    selectedZone = readZoneFromUrlOrStorage() || readDefaultZone();
    updateSelectedZoneUi();
    setStep(2);
    if (!isDesignMode && (cfg.selectableMap || cfg.cardZoneSelect) && !selectedZone) {
      // If someone lands directly on the edit view without choosing a zone,
      // send them back to the dedicated Bölge Seç page instead of showing step 2 inline.
      const zoneUrl = new URL(window.location.href);
      zoneUrl.searchParams.set('view', 'bolge-sec');
      zoneUrl.searchParams.delete('sf_zone');
      window.location.replace(zoneUrl.toString());
    }
  }

  // ---------- Thumbnail click: swap main image ----------
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      if (mainImg && src) {
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src = src;
          mainImg.style.opacity = '1';
        }, 150);
      }
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
  const panels = {
    bireysel: root.querySelector('[data-sf-panel="bireysel"]'),
    aile: root.querySelector('[data-sf-panel="aile"]'),
    kurumsal: root.querySelector('[data-sf-panel="kurumsal"]'),
  };
  const aileCount = root.querySelector('[data-sf-aile-count]');
  const aileNamesWrap = root.querySelector('[data-sf-aile-names]');
  const starName = root.querySelector('[data-sf-star-name]');
  const submitBtn = root.querySelector('[data-sf-submit]');
  const modal = root.querySelector('[data-sf-modal]');
  const companyUrlField = root.querySelector('[data-sf-company-url-field]');
  if (companyUrlField && cfg.requiresCompanyUrl) companyUrlField.hidden = false;

  // ---------- Step 1: yıldız tipi panel switching ----------
  tipiRadios.forEach((r) => {
    r.addEventListener('change', () => {
      Object.entries(panels).forEach(([key, panel]) => {
        if (!panel) return;
        if (key === r.value) {
          panel.hidden = false;
        } else {
          panel.hidden = true;
        }
      });
      updateStarPreview();
      clearError('yildiz_tipi');
    });
  });

  // ---------- Aile: dynamic name inputs ----------
  if (aileCount && aileNamesWrap) {
    aileCount.addEventListener('change', () => {
      const n = parseInt(aileCount.value, 10);
      aileNamesWrap.innerHTML = '';
      if (!n || isNaN(n)) return;
      for (let i = 1; i <= n; i++) {
        const wrap = document.createElement('label');
        wrap.className = 'sf-field';
        wrap.innerHTML = `
          <span class="sf-field__label">Kişi ${i} Ad Soyad</span>
          <input type="text" name="aile_ad_soyad_${i}" data-sf-aile-name="${i}" maxlength="30" placeholder="Ad Soyad" autocomplete="off">
        `;
        aileNamesWrap.appendChild(wrap);
      }
      // First aile name drives the live preview
      const first = aileNamesWrap.querySelector('[data-sf-aile-name="1"]');
      if (first) {
        first.addEventListener('input', updateStarPreview);
      }
      updateStarPreview();
      clearError('aile_kisi_sayisi');
    });
  }

  // ---------- Live star name preview ----------
  function updateStarPreview() {
    const tipi = getTipi();
    let val = '';
    if (tipi === 'bireysel') {
      const i = root.querySelector('[name="bireysel_ad_soyad"]');
      val = i ? i.value : '';
    } else if (tipi === 'aile') {
      const i = root.querySelector('[data-sf-aile-name="1"]');
      val = i ? i.value : '';
    } else if (tipi === 'kurumsal') {
      const i = root.querySelector('[name="kurumsal_sirket"]');
      val = i ? i.value : '';
    }
    if (starName) {
      const words = val.trim().split(/\s+/).filter(Boolean);
      const firstLine = words[0] || '';
      const secondLine = words.slice(1).join(' ');
      starName.classList.toggle('is-long-first', firstLine.length > 8);
      starName.classList.toggle('is-long-second', secondLine.length > 8);
      starName.innerHTML = '';
      if (firstLine) {
        const first = document.createElement('span');
        first.className = 'sf-star__name-line sf-star__name-line--first';
        first.textContent = firstLine;
        starName.appendChild(first);
      }
      if (secondLine) {
        const second = document.createElement('span');
        second.className = 'sf-star__name-line sf-star__name-line--second';
        second.textContent = secondLine;
        starName.appendChild(second);
      }
      fitStarName(starName);
    }
  }

  function fitStarName(el) {
    if (!el) return;
    const lines = Array.from(el.querySelectorAll('.sf-star__name-line'));
    lines.forEach((line) => {
      line.style.fontSize = '';
      line.style.letterSpacing = '';
    });
    // Give the browser one layout tick, then shrink only if the rendered name would overflow
    // its designated text box. This prevents long Turkish names from escaping the plaque/star area.
    window.requestAnimationFrame(() => {
      const boxW = Math.max(1, el.clientWidth);
      const boxH = Math.max(1, el.clientHeight);
      for (let i = 0; i < 8; i++) {
        const overflowW = el.scrollWidth > boxW + 1;
        const overflowH = el.scrollHeight > boxH + 1;
        if (!overflowW && !overflowH) break;
        lines.forEach((line) => {
          const current = parseFloat(window.getComputedStyle(line).fontSize) || 12;
          const next = Math.max(6, current * 0.88);
          line.style.fontSize = next.toFixed(2) + 'px';
          if (overflowW) line.style.letterSpacing = '-0.06em';
        });
      }
    });
  }
  // Bind input listeners on text fields
  root.querySelectorAll('[data-sf-name-source]').forEach((el) => {
    el.addEventListener('input', updateStarPreview);
  });
  root.querySelectorAll('[name="extra_detail"]').forEach((el) => {
    el.addEventListener('change', () => clearError('extra_detail'));
  });

  function getTipi() {
    const checked = root.querySelector('[data-sf-tipi]:checked');
    return checked ? checked.value : null;
  }

  function parsePriceDisplay(value) {
    // Handles both "5.000,00" (TR) and "5,000.00" (EN) money strings: a trailing
    // , or . group of 1-2 digits is decimal; other separators are thousands.
    const raw = String(value || '').replace(/[^\d.,-]/g, '');
    const sep = Math.max(raw.lastIndexOf(','), raw.lastIndexOf('.'));
    let intPart = raw;
    let fracPart = '';
    if (sep >= 0 && raw.length - sep - 1 <= 2) {
      intPart = raw.slice(0, sep);
      fracPart = raw.slice(sep + 1);
    }
    intPart = intPart.replace(/[.,]/g, '');
    const amount = Number.parseFloat(fracPart ? intPart + '.' + fracPart : intPart);
    return Number.isFinite(amount) ? amount : null;
  }

  function formatPriceDisplay(amount) {
    if (!Number.isFinite(amount)) return '';
    return `${Math.round(amount).toLocaleString('tr-TR')} TL`;
  }

  function displayStarType(value) {
    if (value === 'bireysel') return 'Bireysel';
    if (value === 'aile') return 'Aile';
    if (value === 'kurumsal') return 'Kurumsal';
    return value || '';
  }

  // ---------- Validation ----------
  function showError(key, msg) {
    const el = root.querySelector(`[data-sf-error="${key}"]`);
    if (el) el.textContent = msg;
  }
  function clearError(key) {
    const el = root.querySelector(`[data-sf-error="${key}"]`);
    if (el) el.textContent = '';
  }
  function clearAllErrors() {
    root.querySelectorAll('[data-sf-error]').forEach((e) => (e.textContent = ''));
  }

  function validate() {
    clearAllErrors();
    const tipi = getTipi();
    if (!tipi) {
      showError('yildiz_tipi', 'Lütfen bir yıldız tipi seçiniz.');
      return false;
    }

    if (tipi === 'bireysel') {
      const v = root.querySelector('[name="bireysel_ad_soyad"]').value.trim();
      if (!v) {
        showError('bireysel_ad_soyad', 'Lütfen ad soyad giriniz.');
        return false;
      }
      if (v.length > 30) {
        showError('bireysel_ad_soyad', 'En fazla 30 karakter.');
        return false;
      }
    }

    if (tipi === 'aile') {
      const n = parseInt(aileCount.value, 10);
      if (!n) {
        showError('aile_kisi_sayisi', 'Lütfen kişi sayısı seçiniz.');
        return false;
      }
      const inputs = aileNamesWrap.querySelectorAll('input[type="text"]');
      for (const inp of inputs) {
        if (!inp.value.trim()) {
          showError('aile_kisi_sayisi', 'Tüm isim alanlarını doldurun.');
          return false;
        }
      }
    }

    if (tipi === 'kurumsal') {
      const aralik = root.querySelector('[name="kurumsal_aralik"]:checked');
      if (!aralik) {
        showError('kurumsal_aralik', 'Lütfen kişi aralığını seçiniz.');
        return false;
      }
      const sirket = root.querySelector('[name="kurumsal_sirket"]').value.trim();
      if (!sirket) {
        showError('kurumsal_sirket', 'Lütfen şirket / kurum adını giriniz.');
        return false;
      }
      if (cfg.requiresCompanyUrl) {
        const url = root.querySelector('[name="kurumsal_web_url"]')?.value.trim() || '';
        if (!/^https?:\/\/.+\..+/.test(url)) {
          showError('kurumsal_web_url', 'Lütfen QR kod için geçerli firma web adresini giriniz.');
          return false;
        }
      }
    }

    if (cfg.requiresExtraDetail && !root.querySelector('[name="extra_detail"]:checked')) {
      showError('extra_detail', 'Lütfen ürün seçimi yapınız.');
      return false;
    }

    if (zoneRequiresLoca() && !readLocaSelection().number) {
      openLocaModal();
      return false;
    }

    return true;
  }

  // ---------- Build line item properties ----------
  //
  // Customer-visible checkout keys are Turkish. Machine-only linkage fields are
  // underscore-prefixed so checkout/cart hide them while Admin/Flow/Make can still read them.
  function buildProperties() {
    const tipi = getTipi();
    const loca = (cfg.requiresLocaDetails || zoneRequiresLoca()) ? readLocaSelection() : null;
    const zoneName = loca?.shipping ? 'Eve Teslim' : (zoneRequiresLoca() && loca?.number ? formatLocaDisplay(loca.number) : (selectedZone?.name || cfg.zoneName || ''));
    const zoneKey = loca?.shipping ? 'eve_teslim' : (zoneRequiresLoca() ? 'loca' : (selectedZone?.key || cfg.defaultZoneKey || ''));
    const zoneSize = selectedZone?.size || cfg.zoneSize || '';
    const props = {
      'Yıldız Tipi': displayStarType(tipi),
      'Bölge': zoneName,
      _source_version: 'v2-ascii-keys',
      _star_type: tipi, // 'bireysel' | 'aile' | 'kurumsal' — lowercase
      _zone: zoneName,
      _zone_key: zoneKey,
      _zone_size: zoneSize,
    };
    if (selectedZone?.starId || cfg.defaultStarId) props._selected_star_id = String(selectedZone?.starId || cfg.defaultStarId);
    if (cfg.requiresLocaDetails || zoneRequiresLoca()) {
      props['Loca Numarası'] = loca?.shipping ? '' : (loca?.number || '');
      props._loca_numarasi = loca?.shipping ? '' : (loca?.number || '');
      if (cfg.requiresLocaDetails) {
        props['Teslimat Tercihi'] = loca?.shipping ? 'Ürünün evime gelmesini istiyorum' : 'Loca teslimi';
        props._delivery_preference = props['Teslimat Tercihi'];
      }
    }
    if (['premium-yildiz', 'vip-yildiz'].includes(cfg.productHandle)) props._included_plaque = 'true';

    if (tipi === 'bireysel') {
      props['Yıldız Adı'] = root.querySelector('[name="bireysel_ad_soyad"]').value.trim();
      props._star_name = props['Yıldız Adı'];
    } else if (tipi === 'aile') {
      const n = parseInt(aileCount.value, 10);
      props['Kişi Sayısı'] = String(n);
      props._person_count = String(n);
      const inputs = aileNamesWrap.querySelectorAll('input[type="text"]');
      inputs.forEach((inp, idx) => {
        const key = `Yıldız Adı ${idx + 1}`;
        props[key] = inp.value.trim();
        props[`_star_name_${idx + 1}`] = props[key];
      });
    } else if (tipi === 'kurumsal') {
      props['Kurumsal Kişi Aralığı'] = root.querySelector('[name="kurumsal_aralik"]:checked').value;
      props['Şirket Adı'] = root.querySelector('[name="kurumsal_sirket"]').value.trim();
      props._company_range = props['Kurumsal Kişi Aralığı'];
      props._company_name = props['Şirket Adı'];
      if (cfg.requiresCompanyUrl) {
        props['Firma Web Sitesi'] = root.querySelector('[name="kurumsal_web_url"]')?.value.trim() || '';
        props._company_url = props['Firma Web Sitesi'];
        props._requires_qr_code = 'true';
      }
    }

    if (cfg.requiresExtraDetail) {
      const selectedExtra = root.querySelector('[name="extra_detail"]:checked')?.value || '';
      props['Ürün Seçimi'] = selectedExtra === 'takim_imzali_forma' ? 'Takım İmzalı Forma' : 'Takım İmzalı Top';
      props._extra_detail = props['Ürün Seçimi'];
    }

    return props;
  }

  function resolveMainQuantity() {
    const tipi = getTipi();
    if (tipi === 'aile') {
      const n = parseInt(aileCount.value, 10);
      return Number.isFinite(n) && n > 0 ? n : 1;
    }
    return 1;
  }

  function plaqueEntriesForProperties(properties) {
    const tipi = getTipi();
    if (tipi === 'aile') {
      const quantity = resolveMainQuantity();
      const entries = [];
      for (let index = 1; index <= quantity; index += 1) {
        const name = properties[`Yıldız Adı ${index}`] || properties[`_star_name_${index}`] || properties['Yıldız Adı 1'] || properties._star_name_1 || '';
        entries.push({ name, starIndex: String(index) });
      }
      return entries;
    }

    return [{
      name: properties['Yıldız Adı'] || properties._star_name || properties['Şirket Adı'] || properties._company_name || '',
      starIndex: '1',
    }];
  }

  function updatePlaqueModalPricing() {
    if (!modal) return;
    const saleEl = modal.querySelector('.sf-modal__product-sale');
    const compareEl = modal.querySelector('.sf-modal__product-compare');
    const quantity = resolveMainQuantity();

    if (saleEl) {
      const unitSale = parsePriceDisplay(cfg.plaquePrice);
      const totalSale = unitSale == null ? '' : formatPriceDisplay(unitSale * quantity);
      saleEl.textContent = quantity > 1 && totalSale
        ? `${quantity} × ${cfg.plaquePrice} = ${totalSale}`
        : cfg.plaquePrice;
    }

    if (compareEl) {
      const unitCompare = parsePriceDisplay(cfg.plaqueCompareAt);
      const totalCompare = unitCompare == null ? '' : formatPriceDisplay(unitCompare * quantity);
      compareEl.textContent = quantity > 1 && totalCompare
        ? `${quantity} × ${cfg.plaqueCompareAt} = ${totalCompare}`
        : cfg.plaqueCompareAt;
    }
  }

  function updatePlaqueModalCopy() {
    if (!modal) return;
    const acceptBtn = modal.querySelector('[data-sf-modal-accept]');
    if (!acceptBtn) return;
    acceptBtn.textContent = getTipi() === 'aile' ? 'Plaketimiz de Olsun' : 'Plaketim de Olsun';
  }

  // ---------- Submit ----------
  if (form) form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (cfg.soldOut) return;
    if (!validate()) return;

    if (cfg.showPlaque && modal) {
      openModal();
    } else {
      addToCart(false);
    }
  });

  // ---------- Modal ----------
  function openModal() {
    if (!modal) return;
    updatePlaqueModalPricing();
    updatePlaqueModalCopy();
    modal.hidden = false;
    setStep(2);
    document.body.style.overflow = 'hidden';
    const acceptBtn = modal.querySelector('[data-sf-modal-accept]');
    if (acceptBtn) acceptBtn.focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
  }
  if (modal) {
    modal.querySelectorAll('[data-sf-modal-close]').forEach((el) => {
      el.addEventListener('click', closeModal);
    });
    modal.querySelector('[data-sf-modal-accept]').addEventListener('click', () => {
      addToCart(true);
    });
    modal.querySelector('[data-sf-modal-decline]').addEventListener('click', () => {
      addToCart(false);
    });
    document.addEventListener('keydown', (e) => {
      if (!modal.hidden && e.key === 'Escape') closeModal();
    });
  }

  function setStep(n) {
    stepper.forEach((el) => {
      const step = parseInt(el.dataset.step, 10);
      el.classList.toggle('is-active', step <= n);
    });
  }

  // ---------- Add to cart ----------
  async function addToCart(includePlaque) {
    if (cfg.soldOut) return;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sepete ekleniyor...';

    const properties = buildProperties();
    const items = [
      {
        id: parseInt(selectedPackageVariantId(), 10),
        quantity: resolveMainQuantity(),
        properties: properties,
      },
    ];

    if (includePlaque && cfg.plaqueVariantId) {
      plaqueEntriesForProperties(properties).forEach((entry) => {
        items.push({
          id: parseInt(cfg.plaqueVariantId, 10),
          quantity: 1,
          properties: {
            'Yıldız Adı': entry.name,
            _star_name: entry.name,
            _linked_star_index: entry.starIndex,
            _star_number: entry.starIndex,
            _parent_package_handle: cfg.productHandle,
          },
        });
      });
    }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Sepete eklenirken bir hata oluştu.');
      }
      setStep(3);
      window.location.href = '/cart';
    } catch (err) {
      alert(err.message);
      submitBtn.disabled = false;
      submitBtn.textContent = 'Sonraki Adım';
      closeModal();
    }
  }
})();
